/* eslint-disable */

import axios from "axios";

const url = require("../../client_config/config").url;

const state = {
  CloseOut: null,
};

const getters = {};

const actions = {};

const mutations = {
  SET_CLOSEOUT(state, data) {
    state.CloseOut = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
